import { Directive, AfterViewInit, Output, EventEmitter } from '@angular/core';

@Directive({
    selector: '[onCreate]'
})
export class OnCreate implements AfterViewInit {
  @Output() onCreate:EventEmitter<any> = new EventEmitter();

  ngAfterViewInit() {
    this.onCreate.emit('dummy');
  }
}